import { createCustomAppsAdminApi } from '@jarvis/platform-ui';

/** WebOpsApi route backed by the Client Portal database (ItSysAdmin only). */
export const CLIENT_PORTAL_CUSTOM_APPS_API_BASE = '/api/admin/client-portal/custom-apps';

/** Client Portal Entra roles, mirroring ClientPortalUi's CLIENT_PORTAL_ROLES. */
export const CLIENT_PORTAL_APP_ROLES = [
  'SPR-Admin',
  'SPR-PharmCollab',
  'SPR-Collab',
  'SPR-User'
] as const;

export function createClientPortalCustomAppsAdminApi() {
  return createCustomAppsAdminApi(CLIENT_PORTAL_CUSTOM_APPS_API_BASE);
}
